export default {
  titles: {
    pickup: 'Recogida',
    delivery: 'Entrega',
  },
  buttons: {
    confirm: 'Confirmar',
  },
};
